import { ReactComponent as CatalogIcon } from "../../assets/catalogWhite.svg";
import { ReactComponent as VkIcon } from "../../assets/vk.svg";
import { ReactComponent as TelegramIcon } from "../../assets/telegram.svg";
import { ReactComponent as TelegramColorIcon } from "../../assets/telegramColor.svg";
import { ReactComponent as WriteToManagerIcon } from "../../assets/support.svg";
import { ReactComponent as GiftCardIcon } from "../../assets/cart.svg";
import maxPng from "../../assets/max.png";
import styles from "./MainPage.module.css";
import { useNavigate } from "react-router-dom";
import mLogo from "../../assets/m_logo.png";
import bgMain from "../../assets/bgMain.png";
import mainCheck from "../../assets/mainCheck.png";
import mainCrown from "../../assets/mainCrown.png";
import mainLightning from "../../assets/mainLightning.png";
import { useNotificationStore } from "../../store/NotificationStore";
import { useAuth } from "../../app/providers/AuthProvider";

const MainPage = () => {
  const navigate = useNavigate();
  const tg = window.Telegram?.WebApp;
  const { isAuthenticated, startTelegramAuth, isTelegramAuthLoading } =
    useAuth();
  const setNotification = useNotificationStore(
    (state) => state.setNotification,
  );

  const openExternalLink = (url: string) => {
    if (tg?.openLink) {
      tg.openLink(url);
      return;
    }
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const openTelegramLink = (url: string) => {
    if (tg?.openTelegramLink) {
      tg.openTelegramLink(url);
      return;
    }
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleSupportClick = () => {
    window.open("https://t.me/menpoint1", "_blank", "noopener,noreferrer");
  };

  const handleVkClick = () => {
    openExternalLink("https://vk.com/menpoint_riviera");
  };

  const handleTelegramClick = () => {
    openTelegramLink("https://t.me/+AHDwJMuykjhmOWZi");
  };

  const handleMaxClick = () => {
    openExternalLink("https://max.ru/c/-71062798401789/AZ3K83qgLAQ");
  };

  const handleNotificationTrigger = () => {
    setNotification({
      type: "Warning",
      message: "Скоро...",
    });
  };

  const handleTelegramAuthClick = async () => {
    const isSuccess = await startTelegramAuth();
    if (!isSuccess) {
      setNotification({
        type: "Warning",
        message:
          "Не удалось завершить вход. Откройте Telegram, нажмите Start у бота и попробуйте снова.",
      });
    }
  };

  const showVersion =
    tg?.initDataUnsafe?.user?.id === 353357144 ||
    tg?.initDataUnsafe?.user?.id === 6944819896;

  const desktopHighlights = [
    {
      title: "Премиум образы",
      subtitle: "Только лучшее для вас",
      icon: mainCrown,
    },
    {
      title: "Быстрый доступ",
      subtitle: "К нужному за секунды",
      icon: mainLightning,
    },
    {
      title: "Единый аккаунт",
      subtitle: "Всё в одном профиле",
      icon: mainCheck,
    },
  ];

  return (
    <>
      <div className={styles.container}>
        <div
          className={styles.mobileBackground}
          style={{
            backgroundImage: `url(${bgMain})`,
          }}
          aria-hidden="true"
        />
        <div className={styles.mobileOverlay} aria-hidden="true" />
        <div className={styles.content}>
          <header className={styles.mobileTopBar}>
            <div className={styles.mobileBrandLockup}>
              <img src={mLogo} alt="MENPOINT" className={styles.menpoint} />
              <div className={styles.mobileBrandText}>
                <div className={styles.menpointTextText}>ENPOINT</div>
                {showVersion && (
                  <div className={styles.menpointTextVersion}>
                    v.{__APP_VERSION__}
                  </div>
                )}
              </div>
            </div>
          </header>

          <div className={styles.mainPageButtonsContainer}>
            <div className={styles.mobileHeroCopy}>
              <h1 className={styles.mobileHeadline}>
                Стиль, новые находки и удобные покупки в одном пространстве.
              </h1>
              <div className={styles.mpDescription}>
                Выбирайте товары, сохраняйте любимое и переходите в каталог в
                один клик.
              </div>
            </div>

            <div className={styles.mobileHighlights}>
              {desktopHighlights.map((item) => (
                <div key={item.title} className={styles.mobileHighlight}>
                  <span className={styles.mobileHighlightIconBox}>
                    <img
                      src={item.icon}
                      alt=""
                      className={styles.mobileHighlightIcon}
                    />
                  </span>
                  <span className={styles.mobileHighlightContent}>
                    <span className={styles.mobileHighlightTitle}>
                      {item.title}
                    </span>
                    <span className={styles.mobileHighlightSubtitle}>
                      {item.subtitle}
                    </span>
                  </span>
                </div>
              ))}
            </div>

            <div className={styles.mpButtonsContainer}>
              <button
                className={`${styles.blackButton} ${styles.mobilePrimaryButton}`}
                onClick={() => navigate("/catalog")}
              >
                <CatalogIcon
                  className={
                    styles.mpButtonIcon + " " + styles.mpButtonIconCatalog
                  }
                />
                Перейти в каталог
              </button>
              <button
                className={`${styles.grayButton} ${styles.mobileSecondaryButton}`}
                onClick={handleNotificationTrigger}
              >
                <GiftCardIcon className={styles.mpButtonIcon} />
                Подарочная карта
              </button>
              <div className={styles.mpButtonsRow}>
                <button
                  className={styles.socialButton}
                  onClick={handleVkClick}
                  aria-label="ВКонтакте"
                >
                  <VkIcon className={`${styles.socialIcon} ${styles.vkIcon}`} />
                </button>

                <button
                  className={styles.socialButton}
                  onClick={handleMaxClick}
                  aria-label="Max"
                >
                  <img src={maxPng} alt="Max" className={styles.socialIcon} />
                </button>

                <button
                  className={styles.socialButton}
                  onClick={handleTelegramClick}
                  aria-label="Telegram"
                >
                  <TelegramColorIcon
                    className={`${styles.socialIcon} ${styles.telegramColorIcon}`}
                  />
                </button>
              </div>
              <button
                className={styles.blackButton}
                onClick={handleSupportClick}
              >
                <WriteToManagerIcon className={styles.mpButtonIcon} />
                Написать менеджеру
              </button>
              {/* {!isAuthenticated && (
                <button
                  className={`${styles.blackButton} ${styles.mobileAuthButton}`}
                  onClick={() => void handleTelegramAuthClick()}
                  disabled={isTelegramAuthLoading}
                >
                  <TelegramIcon className={styles.mpButtonIcon} />
                  {isTelegramAuthLoading
                    ? "Ожидаем подтверждение..."
                    : "Войти через Telegram"}
                </button>
              )} */}
            </div>
          </div>
        </div>
      </div>

      <div className={styles.desktopPage}>
        <div
          className={styles.desktopBackground}
          style={{
            backgroundImage: `url(${bgMain})`,
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
          }}
          aria-hidden="true"
        />
        <div className={styles.desktopOverlay}>
          <header className={styles.desktopTopBar}>
            <div className={styles.desktopBrandLockup}>
              <img src={mLogo} alt="MENPOINT" className={styles.desktopLogo} />
              <div className={styles.desktopBrandText}>
                <div className={styles.desktopBrandTitle}>ENPOINT</div>
                {showVersion && (
                  <div className={styles.desktopBrandVersion}>
                    v.{__APP_VERSION__}
                  </div>
                )}
              </div>
            </div>

            <div className={styles.desktopQuickNav}>
              <button
                className={styles.desktopQuickNavButton}
                onClick={() => navigate("/catalog")}
              >
                Каталог
              </button>
              {/* <button
                className={styles.desktopQuickNavButton}
                onClick={handleNotificationTrigger}
              >
                Подарочная карта
              </button> */}
              <button
                className={`${styles.desktopQuickNavButton} ${styles.desktopQuickNavButtonWithIcon}`}
                onClick={handleVkClick}
              >
                <VkIcon className={styles.desktopVkIcon} />
                VK
              </button>
              <button
                className={styles.desktopQuickNavButton}
                onClick={handleMaxClick}
              >
                Max
              </button>
              <button
                className={styles.desktopQuickNavButton}
                onClick={handleTelegramClick}
              >
                Telegram
              </button>
              <button
                className={styles.desktopQuickNavButton}
                onClick={handleSupportClick}
              >
                Менеджер
              </button>
              {/* {!isAuthenticated && (
                <button
                  className={`${styles.desktopQuickNavButton} ${styles.desktopQuickNavButtonAccent}`}
                  onClick={() => void handleTelegramAuthClick()}
                  disabled={isTelegramAuthLoading}
                >
                  {isTelegramAuthLoading
                    ? "Ожидаем подтверждение..."
                    : "Войти через Telegram"}
                </button>
              )} */}
            </div>
          </header>

          <div className={styles.desktopStage}>
            <section className={styles.desktopHero}>
              <h1 className={styles.desktopHeadline}>
                Стиль, новые находки и удобные покупки в одном пространстве.
              </h1>
              <p className={styles.desktopLead}>
                Выбирайте товары, сохраняйте любимое и переходите в каталог в
                один клик.
              </p>

              <div className={styles.desktopTags}>
                {desktopHighlights.map((item) => (
                  <div key={item.title} className={styles.desktopTag}>
                    <span
                      className={styles.desktopTagIconBox}
                      aria-hidden="true"
                    >
                      <img
                        src={item.icon}
                        alt=""
                        className={styles.desktopTagMark}
                      />
                    </span>
                    <span className={styles.desktopTagContent}>
                      <span className={styles.desktopTagTitle}>
                        {item.title}
                      </span>
                      <span className={styles.desktopTagSubtitle}>
                        {item.subtitle}
                      </span>
                    </span>
                  </div>
                ))}
              </div>

              <div className={styles.desktopHeroActions}>
                <button
                  className={`${styles.desktopButton} ${styles.desktopHeroPrimary}`}
                  onClick={() => navigate("/catalog")}
                >
                  <CatalogIcon
                    className={
                      styles.desktopButtonIcon +
                      " " +
                      styles.desktopButtonIconCatalog
                    }
                  />
                  Перейти в каталог
                </button>

                <button
                  className={`${styles.desktopButton} ${styles.desktopHeroSecondary}`}
                  onClick={handleNotificationTrigger}
                >
                  <GiftCardIcon className={styles.desktopButtonIcon} />
                  Подарочная карта
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainPage;
